import { FeedbackActionEnum } from '@daymade/api-contracts';
import RoundedButton from 'components/RoundedButton';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useState } from 'react';
import { feedbackApiClient } from 'utils/apiClient';
import HttpStatusCode from 'utils/HttpStatusCode';
import AboutUsModule from './about-us/AboutUsModule';
import AboutUsSiteContainer from './about-us/AboutUsSiteContainer';
import styles from './SubmitPrizeSection2026.module.css';

const SubmitPrizeSection2026 = () => {
  const { currentUser } = useUserStore();
  const [prizeText, setPrizeText] = useState('');
  const [prizeSubmitted, setPrizeSubmitted] = useState(false);

  return (
    <AboutUsModule background="tealGradient">
      <AboutUsSiteContainer>
        {!prizeSubmitted ? (
          <>
            <h2 className="aboutUsTypographyHeaderXlarge">Suggest a prize..</h2>

            <p className="aboutUsTypographyCentered">
              Have something you’d want the chance to win? Let us know!
            </p>
            <div className={styles.controlHolder}>
              <input
                className={styles.textBox}
                placeholder="I'd love to win a..."
                autoComplete="off"
                onChange={(e) => {
                  setPrizeText(e.target.value);
                }}
              />
              <RoundedButton
                style={{ minWidth: '100px' }}
                rebrandDm2025
                onClick={async () => {
                  const userId = currentUser?.id;
                  const result = await feedbackApiClient.public.sendFeedback({
                    body: {
                      action: FeedbackActionEnum.SUGGEST_PRIZE,
                      feedback: {
                        [FeedbackActionEnum.SUGGEST_PRIZE]: {
                          comment: prizeText,
                        },
                      },
                    },
                  });
                  if (result.status === HttpStatusCode.OK) {
                    setPrizeSubmitted(true);
                  }
                }}
              >
                SUBMIT
              </RoundedButton>
            </div>
          </>
        ) : (
          <p
            style={{
              margin: '2em 1em',
              maxWidth: '300px',
              fontWeight: 'bold',
              fontSize: '1.1em',
            }}
          >
            Thanks for your suggestion! We'll be sure to review it soon.
          </p>
        )}
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

export default SubmitPrizeSection2026;

const woo = `
        textarea {
          margin-top: 20px;
          background-color: white;
          font-size: 17px;
          border: none;
          padding: 0.5em 1em;
          width: 100%;
          max-width: 500px;
          height: 90px;
          border-radius: 9px;
        }
      `;
